// src/components/QueryClientSetup.js

import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { BrowserRouter } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import history from './lib/history';
import { PersistGate } from 'redux-persist/integration/react';
import { registerAesKey } from './lib/crypto';
import ErrorBoundary from './components/ErrorBoundary';
import { ReactQueryDevtools } from "react-query/devtools"
import Router from "./components";
// import { SipProvider } from './components/pages/SipHouse/SipContext';
import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';

registerAesKey();

const queryClient = new QueryClient();

const appTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,

      //Custom breakpoint - https://github.com/mui/material-ui/issues/17875 
      extraSmall: 320,
      small: 768,// ipad, tab
      medium: 1024,
      large: 1280,
      extraLarge: 1536, // Another custom breakpoint
    },
  },
});

const QueryClientSetup = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={appTheme}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <ErrorBoundary>
              {/* <SipProvider> */}
              <Router />
              {/* </SipProvider> */}
            </ErrorBoundary>
          </ConnectedRouter>
        </PersistGate>
        <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
      </ThemeProvider>
    </QueryClientProvider>
  </Provider>
);

export { queryClient, QueryClientSetup };
